import { EntityStatus } from './entity.status';

/** Mongoose casts `'false'`, `0` and the like to false, so any supplied `active` short of `true` must be read as a deactivation. */
export function isDeactivationPatch(patch: Partial<Pick<EntityStatus, 'active'>>): boolean {

    return 'active' in patch && patch.active !== true;
}

type SystemStatusFacts = Pick<EntityStatus, 'name' | 'system' | 'systemName'>;

/** Why a settings write may not touch this status, or undefined when it may; code stamps a system status by `systemName`, so losing one breaks that flow on every record. */
export function findSystemStatusRefusal(existing: SystemStatusFacts | null | undefined, patch: Partial<Pick<EntityStatus, 'active' | 'systemName'>> | 'delete'): string | undefined {

    if (!existing?.system) return undefined;

    if (patch === 'delete') return `${existing.name} is a system status and cannot be deleted`;
    if (isDeactivationPatch(patch)) return `${existing.name} is a system status and cannot be deactivated`;
    if ('systemName' in patch && patch.systemName !== existing.systemName) return `${existing.name} is a system status and its system name cannot change`;

    return undefined;
}
